module.exports = __webpack_public_path__ + "images/saaremaa/android-icon-96x96.png";